var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhoneBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 35,
    height: 35,
    transform: "translate(0.247 0.339)",
    fill: "#fff",
    stroke: "black",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(-0.247 -0.339)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    transform: "translate(0.859 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M23.261,28.343a34.973,34.973,0,0,1-9.638-7.668A34.84,34.84,0,0,1,7.005,10.287l-.033-.037,4.773-4.3a1.113,1.113,0,0,0,.083-1.57L8.209.366A1.113,1.113,0,0,0,6.639.283L1.8,4.644h0C-2.124,8.309.558,17.772,7.838,25.86S24.248,37.605,28.3,34.086h0l4.84-4.352a1.113,1.113,0,0,0,.083-1.57l-3.611-4.011a1.109,1.109,0,0,0-1.57-.083l-4.773,4.3-.017-.017Z",
    transform: "translate(0.005 0.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M29.585,20.069c0-8.242-4.223-12.77-12.312-13.195",
    transform: "translate(-1.162 -0.463)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.787
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M34.023,20.1A16.714,16.714,0,0,0,16.514,2.331",
    transform: "translate(-1.111 -0.156)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.787
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneBlack);
export default __webpack_public_path__ + "static/media/icon_phone-black.af925b614e5408ad3742e7a213a1bf8c.svg";
export { ForwardRef as ReactComponent };